handleAction